import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/remove-object-from-photo"
    exact
    path="/consumer/features/remove-object-from-photo"
    component={AsyncPage}
  />,
];
